module.exports = __webpack_public_path__ + "5b2ab829cbe078462f640cb40e885141.pdf";